function aplicarVerMasEnListas(selector) {
  document.querySelectorAll(selector).forEach(function (list) {
    const items = list.querySelectorAll("li");

    if (items.length > 5 && !list.classList.contains("ver-mas-inicializado")) {
      list.classList.add("limited", "ver-mas-inicializado");

      const toggle = document.createElement("div");
      toggle.className = "collection__filter-toggle";
      toggle.textContent = "Ver más";
      list.parentNode.appendChild(toggle);

      toggle.addEventListener("click", function () {
        const isLimited = list.classList.contains("limited");

        if (isLimited) {
          list.classList.remove("limited");
          toggle.textContent = "Ver menos";
        } else {
          list.classList.add("limited");
          toggle.textContent = "Ver más";
        }
      });
    }
  });
}

function aplicarVerMas() {
  aplicarVerMasEnListas(".collection__filter-checkbox-list");
  aplicarVerMasEnListas(".mobile-collection__filter-checkbox-list");
}

document.addEventListener("DOMContentLoaded", function () {
  aplicarVerMas();

  const targetNode = document.querySelector("main");

  if (targetNode) {
    const observer = new MutationObserver(() => {
      aplicarVerMas();
    });

    observer.observe(targetNode, {
      childList: true,
      subtree: true,
    });
  }
});
